import React from "react";
import QRCode from "react-qr-code";

export const templates = {
  classic: {
    name: "Classic Wedding",
    className: "template-classic",
    component: ({ event, qrUrl }) => (
      <div
        className="card-design classic-wedding p-4 p-md-5 text-center shadow-lg"
        style={{
          background: "#fff",
          border: "10px double var(--primary)",
          minHeight: "600px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          color: "var(--on-surface)",
          fontFamily: "var(--font-headline)",
        }}
      >
        <div className="floral-top mb-3 text-primary fs-3">🌹 ✨ 🌹</div>

        {event.eventPhoto && (
          <div
            className="promo-image mx-auto mb-4"
            style={{
              width: "180px",
              height: "180px",
              borderRadius: "50%",
              border: "5px solid var(--primary-dim)",
              overflow: "hidden",
              shadow: "var(--shadow-md)",
            }}
          >
            <img
              src={event.eventPhoto}
              alt="Promo"
              className="w-100 h-100 object-cover"
            />
          </div>
        )}

        <h2 className="display-6 fw-black mb-0">دعوة لحضور</h2>
        <h1 className="display-5 display-md-3 fw-black text-primary my-3">
          {event.name}
        </h1>
        <p className="fs-5 fs-md-4 arabic-leading fw-medium px-3">
          نتشرف بدعوتكم لمشاركتنا أجمل اللحظات وصناعة ذكريات تدوم للأبد.
        </p>

        <div className="my-4 p-4 bg-surface-variant rounded-4 d-inline-block mx-auto border border-primary-dim shadow-sm">
          <QRCode value={qrUrl} size={140} />
          <p className="mt-2 mb-0 fw-bold small text-primary">
            امسح الكود وشاركنا الصور ✨
          </p>
        </div>

        <div className="event-info fs-5 mt-4">
          {event.eventDate && (
            <div className="mb-2">
              📅{" "}
              {new Date(event.eventDate).toLocaleDateString("ar-EG", {
                dateStyle: "full",
              })}
            </div>
          )}
          {event.locationName && <div>📍 {event.locationName}</div>}
        </div>
        <div className="floral-bottom mt-3 text-primary fs-3">🌹 ✨ 🌹</div>
      </div>
    ),
  },
  royal: {
    name: "Royal Gold",
    className: "template-royal",
    component: ({ event, qrUrl }) => (
      <div
        className="card-design royal-gold p-4 p-md-5 text-center shadow-lg"
        style={{
          background: "linear-gradient(135deg, #1A3358 0%, #0d1a2d 100%)",
          border: "8px solid #C9A97A",
          minHeight: "600px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          color: "#C9A97A",
          fontFamily: "var(--font-headline)",
        }}
      >
        <div className="crown mb-2 fs-1">👑</div>

        {event.eventPhoto && (
          <div
            className="promo-image mx-auto mb-4"
            style={{
              width: "220px",
              height: "140px",
              borderRadius: "15px",
              border: "3px solid #C9A97A",
              overflow: "hidden",
              shadow: "0 10px 20px rgba(0,0,0,0.3)",
            }}
          >
            <img
              src={event.eventPhoto}
              alt="Promo"
              className="w-100 h-100 object-cover"
            />
          </div>
        )}

        <h1 className="display-5 display-md-4 fw-black text-gold mb-3">
          {event.name}
        </h1>
        <div
          className="divider mx-auto my-3"
          style={{ width: "80px", height: "3px", background: "#C9A97A" }}
        ></div>
        <p className="fs-5 fs-md-4 px-4 text-white opacity-90 arabic-leading">
          نهديكم أطيب التحايا وندعوكم لحفلنا المنتظر لنحتفل معاً بيومنا المميز.
        </p>

        <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4 my-4">
          <div className="p-3 bg-white rounded-4 shadow-sm border-gold">
            <QRCode value={qrUrl} size={120} />
          </div>
          <div className="event-details text-white fs-5 text-md-start">
            {event.eventDate && (
              <div className="mb-2">
                🗓️ {new Date(event.eventDate).toLocaleDateString("ar-EG")}
              </div>
            )}
            {event.locationName && <div>🏰 {event.locationName}</div>}
          </div>
        </div>

        <div className="mt-4 small text-gold fw-bold tracking-widest uppercase">
          يومك
        </div>
      </div>
    ),
  },
  modern: {
    name: "Modern Clean",
    className: "template-modern",
    component: ({ event, qrUrl }) => (
      <div
        className="card-design modern-clean p-4 p-md-5 text-end shadow-lg"
        style={{
          background: "var(--bg)",
          borderRadius: "40px",
          border: "1px solid var(--primary-dim)",
          minHeight: "600px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          color: "var(--on-surface)",
          fontFamily: "var(--font-headline)",
          overflow: "hidden",
        }}
      >
        <div className="d-flex flex-column flex-md-row gap-5 items-start">
          <div className="flex-grow-1">
            <span className="badge bg-primary px-4 py-2 rounded-pill fs-6 mb-4 shadow-sm">
              دعوة خاصة
            </span>
            <h1 className="display-5 display-md-3 fw-black mb-4">
              {event.name}
            </h1>
            <p className="fs-6 fs-md-5 text-on-surface-variant mb-5 arabic-leading">
              {event.description ||
                "انضم إلينا في يوم لا ينسى لنصنع أجمل الذكريات معاً ونوثق كل لحظة سعيدة."}
            </p>
          </div>

          {event.eventPhoto && (
            <div
              className="promo-image shrink-0 rounded-4 shadow-xl border-4 border-white rotate-3 overflow-hidden"
              style={{ width: "240px", height: "320px" }}
            >
              <img
                src={event.eventPhoto}
                alt="Promo"
                className="w-100 h-100 object-cover"
              />
            </div>
          )}
        </div>

        <div className="d-flex align-items-center gap-4 flex-row-reverse flex-wrap justify-content-end mt-5">
          <div className="bg-white p-3 rounded-4 shadow-sm border border-primary-dim">
            <QRCode value={qrUrl} size={110} />
          </div>
          <div className="text-end">
            <div className="fw-black fs-4 mb-1">
              📅{" "}
              {event.eventDate
                ? new Date(event.eventDate).toLocaleDateString("ar-EG")
                : "قريباً"}
            </div>
            <div className="text-primary fw-bold">
              📍 {event.locationName || "بانتظار التفاصيل"}
            </div>
          </div>
        </div>
      </div>
    ),
  },
  vibrant: {
    name: "Party Vibrant",
    className: "template-vibrant",
    component: ({ event, qrUrl }) => (
      <div
        className="card-design party-vibrant p-4 p-md-5 text-center shadow-lg"
        style={{
          background: "var(--grad-hero)",
          borderRadius: "20px",
          minHeight: "600px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "var(--on-surface)",
          fontFamily: "var(--font-headline)",
          position: "relative",
          overflow: "hidden",
          border: "1px solid var(--primary-dim)",
        }}
      >
        <div
          className="confetti position-absolute w-100 h-100 opacity-25"
          style={{ pointerEvents: "none" }}
        >
          🎉 ✨ 🎈 🎊
        </div>

        <div className="content-box position-relative z-1">
          <h1 className="display-4 display-md-2 fw-black mb-2 text-primary">
            يلا نحتفل!
          </h1>
          <h2 className="display-6 display-md-5 fw-black mb-4 text-primary">
            {event.name}
          </h2>

          {event.eventPhoto && (
            <div
              className="promo-image mx-auto mb-5 rotate-[-2deg] rounded-4 border-8 border-white shadow-2xl overflow-hidden"
              style={{ width: "280px", height: "200px" }}
            >
              <img
                src={event.eventPhoto}
                alt="Promo"
                className="w-100 h-100 object-cover"
              />
            </div>
          )}

          <div className="d-flex flex-column align-items-center gap-4">
            <div
              className="bg-white p-4 rounded-circle d-inline-block mx-auto shadow-lg"
              style={{
                width: "180px",
                height: "180px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                border: "5px solid var(--primary-dim)",
              }}
            >
              <QRCode value={qrUrl} size={110} />
              <div className="text-primary fw-bold mt-2 text-[10px]">
                امسح وشارك
              </div>
            </div>

            <div
              className="glass-info p-3 rounded-celebration shadow-sm w-100"
              style={{
                background: "rgba(139, 73, 62, 0.15)",
                backdropFilter: "blur(10px)",
              }}
            >
              <h4 className="fw-black mb-0 text-primary">
                {event.locationName} |{" "}
                {event.eventDate
                  ? new Date(event.eventDate).toLocaleDateString("ar-EG")
                  : ""}
              </h4>
            </div>
          </div>
        </div>
      </div>
    ),
  },
};

const InvitationCard = ({ event, templateId, qrUrl }) => {
  const Template = templates[templateId]?.component || templates.classic.component;
  return <Template event={event} qrUrl={qrUrl} />;
};

export default InvitationCard;
